import React from "react";

export const Button = ({ title, onClick, ...other }) => (
  <button className="x-button" onClick={onClick} {...other}>
    {title}
  </button>
);
